"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXPECT_CART_XHR_FAKE_HEADER = exports.monitorForCartChanges = void 0;
var parse_url_1 = __importDefault(require("parse-url"));
/**
 * Set up all known methods for detect cart updates.
 * @param cart BaseCart implementation to notify of changes.
 */
function monitorForCartChanges(cart) {
    var callback = function (cartData) {
        // TODO
        void cart.notifyCartUpdatedExternally();
    };
    detectViaXhrPatch(callback);
    detectViaFetchPatch(callback);
    detectViaLegacyShopifyGlobalCallback(callback);
}
exports.monitorForCartChanges = monitorForCartChanges;
var cartAjaxApiPaths = /\/cart\/(?:add|update|change|clear)\/(?:\.js|\.json)?$/;
// This header is added by the AjaxApi to indicate to these hooks that an XHR
// is being sent by the theme and doesn't need to be handled by these hooks
// It's automatically removed and never actually sent in requests.
exports.EXPECT_CART_XHR_FAKE_HEADER = '__SALVO_EXPECT_CART_REQUESTS';
// Patches XMLHttpRequest to detect calls to the Cart AJAX API endpoints
// This is the same method that Shopify's Trekkie uses to detect add-to-cart
// for analytics, so it should be fairly reliable.
// eslint-disable-next-line max-len
// (for example see https://cdn.shopify.com/shopifycloud/shopify/assets/shop_events_listener-eb19870e6f215e4e4acd8067d24ecfcbfee2d96d96aa8607e8fd45edf40eacc6.js)
function detectViaXhrPatch(callback) {
    function handleResponse(xhr) {
        if (xhr.__expected) {
            return;
        }
        var pathname = (0, parse_url_1.default)(xhr.__url).pathname;
        if (pathname.match(cartAjaxApiPaths)) {
            return;
        }
        callback();
    }
    if (!window.XMLHttpRequest) {
        // Probably in node
        return false;
    }
    var originalOpen = window.XMLHttpRequest.prototype.open;
    function patchedOpen(method, url, async, username, password) {
        this.__expected = false;
        // Store URL on the XHR so we can check it later
        this.__url = url;
        this.addEventListener('load', function () {
            handleResponse(this);
        });
        var args = [method, url];
        if (async !== undefined) {
            args.push(async);
        }
        if (username !== undefined) {
            args.push(username);
        }
        if (password !== undefined) {
            args.push(password);
        }
        return originalOpen.apply(this, args);
    }
    var originalSetRequestHeader = window.XMLHttpRequest.prototype.setRequestHeader;
    function patchedSetRequestHeader(name, value) {
        if (name == exports.EXPECT_CART_XHR_FAKE_HEADER) {
            // This XHR was created by the AjaxApi's axios instance. We can ignore it.
            this.__expected = true;
            // Don't actually set the fake header
            return;
        }
        return originalSetRequestHeader.apply(this, [name, value]);
    }
    window.XMLHttpRequest.prototype.open = patchedOpen;
    window.XMLHttpRequest.prototype.setRequestHeader = patchedSetRequestHeader;
    return true;
}
// Equiviliant to the above, but for the Fetch API rather than XHR
function detectViaFetchPatch(callback) {
    function handleResponse(res) {
        var pathname = (0, parse_url_1.default)(res.url).pathname;
        if (pathname.match(cartAjaxApiPaths)) {
            return;
        }
        callback();
    }
    // Patch fetch() to intercept response
    if (!window.fetch || typeof window.fetch != 'function') {
        return false;
    }
    var originalFetch = window.fetch;
    window.fetch = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, originalFetch.apply(this, args)];
                    case 1:
                        response = _a.sent();
                        handleResponse(response);
                        return [2 /*return*/, response];
                }
            });
        });
    };
    return true;
}
// Shopify.onCartUpdate global callback
// This is a legacy hook that was implemented by the AJAX API helper functions
// I'm not sure if it's ever actually triggered anymore.
function detectViaLegacyShopifyGlobalCallback(callback) {
    var global = window;
    if (!global.Shopify) {
        return false;
    }
    var old = global.Shopify.onCartUpdate;
    global.Shopify.onCartUpdate = function (cart) {
        if (old) {
            old(cart);
        }
        callback(cart);
    };
    return true;
}
//# sourceMappingURL=hooks.js.map